import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function ConfirmDialog({
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  isOpen,
  message,
  onCancel,
  onConfirm,
  title = "Are you sure?"
}) {
  if (!isOpen) return null;

  return (
    <Dialog title={title} onClose={onCancel} width={420}>
      <p className="paragraph">{message}</p>
      <DialogActionsBar>
        <Button onClick={onCancel}>{cancelLabel}</Button>
        <Button themeColor="error" icon="check" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}
